import React, { useEffect, useState} from "react";
import { Table, Button } from 'reactstrap';
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import { useTable } from "hooks";
import EditShiftTable from "./EditShiftTable";

export const ShiftsList = ({ match, url = "shifts", t, payroll, deleteItem, load}) => {
    const [upcoming, setUpcoming] = useState(true);
    const {
        TableContainer,
        data,
        PayrollTableDataFetch,
        TableSearch,
        ViewingRecords,
        Pagination,
        refreshData,
        filters,
    } = useTable({
        url,
        filters: {
          upcoming,
        },
        limit: 20
      });

      useEffect(()=>{
        refreshData()
      }, [load])

    return (
        <>
            <h5 className="my-2"><Trans> Shifts list </Trans></h5>

            <div className="d-flex justify-content-between align-items-center">
                <TableSearch className="my-0 flex-grow-1 " />
            </div>
            <TableContainer>
                <Table className="no-wrap text-center" responsive>
                    <thead>
                        <tr className="border-0">
                            <th className="border-0"><Trans>Shift name</Trans></th>
                            <th className="border-0"><Trans>Date from</Trans></th>
                            <th className="border-0"><Trans>Date to</Trans></th>
                            <th className="border-0"><Trans>Time from</Trans></th>
                            <th className="border-0"><Trans>Time to</Trans></th>
                            <th className="border-0"><Trans>Total Time</Trans></th>
                            <th className="border-0"><Trans>Action</Trans></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.results.map((item, i) => {
                            return (
                                <tr key={i}>
                                    <td className="border-0">{item.name}</td>
                                    <td className="border-0">{item.date_from}</td>
                                    <td className="border-0">{item.date_to}</td>
                                    <td className="border-0">{item.time_from}</td>
                                    <td className="border-0">{item.time_to2 ? item.time_to2 : item.time_to}</td>
                                    <td className="border-0">{item.total_time}</td>
                                    <td className="border-0">
                                        {/* <button onClick={() => deleteItem(item.id)}> Del </button> */}
                                        <Link
                                            className="btn btn-primary btn-sm mr-2 fix-bg-edit-btn"
                                            style={{ borderRadius: "6px", backgroundColor: "rgb(114, 181, 102)", borderColor: "rgb(114, 181, 102)", padding: "7.2px 10.5px" }}
                                            to={`${match.url}/${item.id}`}
                                        >
                                            {/* <Button color="success" className='mr-2'> */}
                                            <i className="fa fa-edit" aria-hidden="true" style={{ fontSize: '14px' }}></i>
                                            {/* </Button> */}
                                        </Link>

                                        <Button onClick={() => deleteItem(item.id)} color="danger"><i className="fa fa-trash" aria-hidden="true"></i></Button>
                                    </td>
                                </tr>
                            )
                        })}

                    </tbody>
                </Table>
            </TableContainer>
            <PayrollTableDataFetch />
            <div className="d-flex justify-content-between">
                <div><ViewingRecords noCount/></div>
                <div><Pagination /></div>
            </div>
        </>
    );
};


export default ShiftsList;